// @ts-nocheck

// Graph plugins for Chart.js to enhance graph interactivity and visuals
export const verticalLineIntersect = {
  id: "verticalLine",
  afterDraw: (chart) => {
    if (chart?.tooltip && chart.tooltip?._active && chart.tooltip._active.length) {
      const ctx = chart.ctx;
      const activePoint = chart.tooltip._active[0];

      if (activePoint?.element?.x !== undefined) {
        const x = activePoint.element.x;
        const topY = chart.scales.y.top;
        const bottomY = chart.scales.y.bottom;

        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, topY);
        ctx.lineTo(x, bottomY);
        ctx.lineWidth = 1;
        ctx.strokeStyle = "rgba(0, 0, 0, 0.8)";
        ctx.stroke();
        ctx.restore();
      }
    }
  },
};
// Plugin to dismiss tooltip when clicking outside the chart area
export const dismissTooltipPlugin = {
  id: "dismissTooltip",
  beforeEvent(chart, args) {
    const event = args.event;
    if (event.type === "click") {
      const chartArea = chart.chartArea;
      if (
        event.x < chartArea.left ||
        event.x > chartArea.right ||
        event.y < chartArea.top ||
        event.y > chartArea.bottom
      ) {
        if (chart?.tooltip && typeof chart.tooltip.setActiveElements === "function") {
          chart.tooltip.setActiveElements([], {});
          chart.update();
        }
      }
    }
  },
};
